(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxWorkstationGroups(
    GroupListPaging, URLS
  ) {
    return {
      restrict: 'EA',
      scope: {
        workstation: '=workstation',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationGroups/workstationGroups.template.html',
      link: function(scope) {

        scope.groupListPaging = new GroupListPaging();
        scope.groupList = null;
        scope.noDataMessage = 'NoSearchResultGroups';

        (function() {
          getGroups();
        })();

        function getGroups () {
          scope.workstation.getGroups(scope.groupListPaging).then(function(groupListObject) {
            scope.groupContainer = groupListObject;
          }).catch(function(error){});
        }

        scope.getNextGroupsPage = function(showPrevious) {
          if (showPrevious) {
            if (scope.groupListPaging.pagingCriteria.page > 0) {
              scope.groupListPaging.pagingCriteria.page--;
            }
          } else {
            if (scope.groupListPaging.pagingCriteria.page + 1 < scope.groupContainer.page.totalPages) {
              scope.groupListPaging.pagingCriteria.page++;
            }
          }
          getGroups();
        }

        scope.editSelectedGroup = function(group) {
          var url = URLS.GROUP_PROPERTIES.replace(URL_PARAMS.GROUP_ID.LOCATION, group.customProperties.id);
          $location.path(url)
        }


      }
    };
  }

  pxWorkstationGroups.$inject = ['GroupListPaging', 'URLS'];

  angular
    .module('printix-admin')
    .directive('pxWorkstationGroups', pxWorkstationGroups);

})();
